import { Injectable } from "@angular/core";
import { PrimaryTransactionSearch } from "./classes";

@Injectable()
export class UserSessionContex
{
    public transSearchObj: PrimaryTransactionSearch;
    public static WhiteLableSession: string;
}